import React from 'react';
import { IIconProps } from './utils';

export const ResetPassword = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="2 2 27 27"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.375 8.90625C16.2735 8.90625 17.8125 10.4453 17.8125 12.3438V14.5312C17.8125 14.5352 17.8116 14.5391 17.8115 14.543C18.342 14.6184 18.75 15.0737 18.75 15.625V18.9062C18.75 19.5103 18.2603 20 17.6562 20H11.0938C10.4897 20 10 19.5103 10 18.9062V15.625C10 15.074 10.4075 14.6188 10.9375 14.543V12.3438C10.9375 10.4453 12.4765 8.90625 14.375 8.90625ZM14.375 16.1719C13.7709 16.1719 13.2812 16.6616 13.2812 17.2656C13.2812 17.8697 13.7709 18.3594 14.375 18.3594C14.9791 18.3594 15.4688 17.8697 15.4688 17.2656C15.4688 16.6616 14.9791 16.1719 14.375 16.1719ZM14.375 11.4062C13.8572 11.4062 13.4375 11.826 13.4375 12.3438V14.5312H15.3125V12.3438C15.3125 11.826 14.8928 11.4062 14.375 11.4062Z"
      fill={fill}
    />
    <path
      d="M24.4993 14.375C24.4993 8.50697 19.8544 3.75 14.1246 3.75C8.39488 3.75 3.75 8.50697 3.75 14.375C3.75 20.243 8.39488 25 14.1246 25C15.5004 25 16.8137 24.7257 18.0151 24.2277M24.4993 14.375L26.25 12.6042M24.4993 14.375L22.4244 13.1633M22.2238 21.0156C22.551 20.5976 22.848 20.1538 23.1113 19.6875"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
